import styled from 'styled-components'

import { boxModelTypes, cssTypes, displayTypes, textTypes } from '../types'
import { boxModel, css, display, text } from '../util'

/**
 * @namespace Span
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const Span = styled.span`
  ${boxModel};
  ${css};
  ${display};
  ${text};
`

/**
 * @name defaultProps
 * @memberof Span
 * @desc Primitive's default properties
 */
Span.defaultProps = {
  fontSize: 'baseFontSize',
  margin: [0],
  padding: [0],
  size: ['auto'],
}

/**
 * @name propTypes
 * @memberof Span
 * @desc Primitive's prop type definitions
 */
Span.propTypes = {
  ...boxModelTypes,
  ...cssTypes,
  ...displayTypes,
  ...textTypes,
}

/** @component */
export default Span
